import { ComputerDesktopIcon } from '@heroicons/react/24/outline';
export const DesktopComputerIcon = ComputerDesktopIcon;
